export default class ChartColorService {
    static get Green() {
        return {
            backgroundColor: "rgba(132, 217, 145, 0.2)",
            borderColor: "rgba(132, 217, 145, 0.7)",
        };
    }
    static get Blue() {
        return {
            backgroundColor: "rgba(64, 186, 189, 0.2)",
            borderColor: "rgba(64, 186, 189, 0.7)",
        };
    }
    static get LightBlue() {
        return {
            backgroundColor: "rgba(160, 221, 222, 0.2)",
            borderColor: "rgba(160, 221, 222, 0.7)",
        };
    }
    static get DarkBlue() {
        return {
            backgroundColor: "rgb(92,119,219, 0.2)",
            borderColor: "rgb(92,119,219, 0.7)",
        };
    }
    static get Orange() {
        return {
            backgroundColor: "rgba(248, 161, 63, 0.2)",
            borderColor: "rgba(248, 161, 63, 0.7)",
        };
    }
    static get Red() {
        return {
            backgroundColor: "rgba(244, 80, 59, .2)",
            borderColor: "rgba(244, 80, 59, .7)",
        };
    }
    static get Pink() {
        return {
            backgroundColor: "rgba(234, 83, 149, 0.2)",
            borderColor: "rgba(234, 83, 149, 0.7)",
        };
    }
    static get LightPink() {
        return {
            backgroundColor: "rgba(249, 203, 223, 0.2)",
            borderColor: "rgba(249, 203, 223, 0.7)",
        };
    }
    static get Purple() {
        return {
            backgroundColor: "rgb(122,95,219, 0.2)",
            borderColor: "rgb(122,95,219, 0.7)",
        };
    }
    static get Gray() {
        return {
            backgroundColor: "rgba(134, 140, 151, .2)",
            borderColor: "rgba(134, 140, 151, .7)",
        };
    }
    static get Colors() {
        return [
            ChartColorService.Green,
            ChartColorService.Blue,
            ChartColorService.DarkBlue,
            ChartColorService.Orange,
            ChartColorService.Red,
            ChartColorService.Pink,
            ChartColorService.Purple,
            ChartColorService.Gray,
        ];
    }
}
